import React, { useState } from 'react'
import * as ReactBootstrap from 'react-bootstrap'
import SlidingPane from 'react-sliding-pane'
import { connect } from 'react-redux'
import { useDispatch } from 'react-redux'

import * as components from '../../components'
import EditPenaltyForm, {EditPenaltyFormData} from './EditPenaltyForm'
import * as rest from '../../services'
import { showErrorToast, showSuccessToast } from '../../state/toasts'
import {PenaltyAmount} from "../../api";



export interface EditLoanerPenaltyProps {
  title: string
  onSubmit: () => void
  item: PenaltyAmount
}

export const EditLoanerPenalty: React.FC<EditLoanerPenaltyProps> = ({
  title,
  onSubmit,
  item,
}) => {
  const dispatch = useDispatch()
  const [isPaneOpen, setIsPaneOpen] = useState<boolean>(false)

  const updatePenalty = (data: EditPenaltyFormData) => {
    new rest.PenaltyService(item.url)
      .makePutRequest({...item,...data})
      .then(() => {
        onSubmit()
        dispatch(showSuccessToast('Success', 'Penalty  item edited successfully.'))
      })
      .catch((error: any) => {
        const message = JSON.stringify(error?.response?.data || error)
        dispatch(showErrorToast('Error', message))
      })
  }

  const EditPenaltyFormWithData = connect(() => ({
    initialValues: { cost:item.cost },
  }))(EditPenaltyForm)

  return (
    <>
      <ReactBootstrap.Dropdown.Item onClick={() => setIsPaneOpen(true)}>
        {components.ICONS.EDIT} Edit
      </ReactBootstrap.Dropdown.Item>

      <SlidingPane
        overlayClassName="on-top"
        isOpen={isPaneOpen}
        title={title}
        onRequestClose={() => setIsPaneOpen(false)}
      >
        <EditPenaltyFormWithData onSubmit={updatePenalty} />
      </SlidingPane>
    </>
  )
}
